import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Modal from '../Modal'
import { cancelarParte } from '../../api/client'

// "Cancelar parte": for a parte opened by mistake or for a test. It asks
// why, and says what follows: the parte stops being open without counting
// as a repair, an F/S unit goes back to Operativo, running work stops and
// its work order is cancelled. The parte is kept (marked cancelled).
export default function CancelarParteModal({ parte, onClose, onCancelled }) {
  const { t } = useTranslation('engineering')
  const [motivo, setMotivo] = useState('')
  const [error, setError] = useState('')
  const [saving, setSaving] = useState(false)

  const submit = async (e) => {
    e.preventDefault()
    if (!motivo.trim()) { setError(t('partes.cancelar.motivoRequerido')); return }
    setSaving(true)
    setError('')
    try {
      onCancelled(await cancelarParte(parte.id, motivo.trim()))
      onClose()
    } catch (err) {
      const d = err.response?.data?.detail
      setError(typeof d === 'string' ? `${t('partes.cancelar.failed')} (${d})` : d?.message || t('partes.cancelar.failed'))
    } finally {
      setSaving(false)
    }
  }

  return (
    <Modal title={t('partes.cancelar.title', { numero: parte.numero })} onClose={onClose}>
      <form onSubmit={submit} className="space-y-4">
        <p className="text-sm text-gray-600">
          <span className="font-medium text-gray-900">{parte.nombre}</span> · {parte.unidad_codigo}
        </p>
        <ul className="text-xs text-gray-600 list-disc pl-4 space-y-1">
          <li>{t('partes.cancelar.efectoNoCuenta')}</li>
          {parte.implica_fs && <li>{t('partes.cancelar.efectoUnidad', { codigo: parte.unidad_codigo })}</li>}
          <li>{t('partes.cancelar.efectoTrabajo')}</li>
          {parte.ot && <li>{t('partes.cancelar.efectoOt', { codigo: parte.ot.codigo })}</li>}
        </ul>
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1">{t('partes.cancelar.motivo')} *</label>
          <textarea rows={2} autoFocus value={motivo} onChange={e => setMotivo(e.target.value)}
            placeholder={t('partes.cancelar.motivoPlaceholder')}
            className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-gray-200" />
        </div>
        {error && <p className="text-red-500 text-xs">{error}</p>}
        <div className="flex justify-end gap-2 pt-2">
          <button type="button" onClick={onClose}
            className="bg-white border border-gray-200 text-gray-600 px-4 py-2 rounded-lg text-sm font-medium hover:bg-gray-50 transition-colors">
            {t('partes.cancelar.volver')}
          </button>
          <button type="submit" disabled={saving || !motivo.trim()}
            className="bg-rose-600 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-rose-700 disabled:opacity-40 transition-colors">
            {t('partes.cancelar.confirmar')}
          </button>
        </div>
      </form>
    </Modal>
  )
}
